import api from "./api"; // Centralized authenticated Axios instance

// ─── District Managers CRUD ──────────────────────────────────────────────────

export async function getDistrictManagers() {
  try {
    const res = await api.get("/district-managers");
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to fetch district managers: ${errorText}`);
  }
}

export async function createDistrictManager(data) {
  try {
    const res = await api.post("/district-managers", data);
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to create district manager: ${errorText}`);
  }
}

export async function updateDistrictManager(id, data) {
  if (!Number.isInteger(Number(id))) {
    throw new Error("District Manager ID must be an integer");
  }
  try {
    const res = await api.put(`/district-managers/${id}`, data);
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to update district manager: ${errorText}`);
  }
}

export async function deleteDistrictManager(id) {
  if (!Number.isInteger(Number(id))) {
    throw new Error("District Manager ID must be an integer");
  }
  try {
    const res = await api.delete(`/district-managers/${id}`);
    return res.data || true;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to delete district manager: ${errorText}`);
  }
}

// ─── Tier Multipliers ─────────────────────────────────────────────────────────

export async function getTierMultipliers() {
  try {
    const res = await api.get("/district-managers/tier-multipliers");
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to fetch tier multipliers: ${errorText}`);
  }
}

export async function updateTierMultipliers(data) {
  if (!Array.isArray(data)) {
    throw new Error("Tier multipliers data must be an array");
  }
  try {
    const res = await api.put("/district-managers/tier-multipliers", data);
    return res.data;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to update tier multipliers: ${errorText}`);
  }
}

// ─── Commission Report ────────────────────────────────────────────────────────

/**
 * Fetch a district manager commission report.
 *
 * @param {{ year: number, periodType: "month"|"quarter"|"ytd", month?: number, quarter?: string }} opts
 */
export async function getDistrictManagerCommissions({
  year,
  periodType,
  month,
  quarter,
}) {
  const params = { year: String(year) };

  if (periodType === "month") {
    params.month = String(month);
  } else if (periodType === "quarter") {
    params.q = quarter;
  } else {
    params.ytd = "true";
  }

  try {
    const res = await api.get("/district-managers/commissions", { params });
    const json = res.data;

    if (json.success === false) {
      throw new Error(json.message);
    }

    return json.data ?? json;
  } catch (error) {
    const errorText = error.response?.data?.message || error.message;
    throw new Error(`Failed to fetch commission report: ${errorText}`);
  }
}

// const API_BASE = "http://10.5.21.42:5000/api/district-managers";
// const TIERS_BASE =
//   "http://10.5.21.42:5000/api/district-managers/tier-multipliers";
// const COMMISSIONS_BASE =
//   "http://10.5.21.42:5000/api/district-managers/commissions";

// export async function getDistrictManagers() {
//   const res = await fetch(API_BASE);
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to fetch district managers: ${errorText}`);
//   }
//   return res.json();
// }

// export async function createDistrictManager(data) {
//   const res = await fetch(API_BASE, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data),
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to create district manager: ${errorText}`);
//   }
//   return res.json();
// }

// export async function updateDistrictManager(id, data) {
//   if (!Number.isInteger(id)) {
//     throw new Error("District Manager ID must be an integer");
//   }
//   const res = await fetch(`${API_BASE}/${id}`, {
//     method: "PUT",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data),
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to update district manager: ${errorText}`);
//   }
//   return res.json();
// }

// export async function deleteDistrictManager(id) {
//   if (!Number.isInteger(id)) {
//     throw new Error("District Manager ID must be an integer");
//   }
//   const res = await fetch(`${API_BASE}/${id}`, {
//     method: "DELETE",
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to delete district manager: ${errorText}`);
//   }
//   return true;
// }

// // ─── Tier Multipliers ─────────────────────────────────────────────────────────

// export async function getTierMultipliers() {
//   const res = await fetch(TIERS_BASE);
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to fetch tier multipliers: ${errorText}`);
//   }
//   return res.json();
// }

// export async function updateTierMultipliers(data) {
//   if (!Array.isArray(data)) {
//     throw new Error("Tier multipliers data must be an array");
//   }
//   const res = await fetch(TIERS_BASE, {
//     method: "PUT",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data),
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to update tier multipliers: ${errorText}`);
//   }
//   return res.json();
// }

// // ─── Commission Report ────────────────────────────────────────────────────────

// /**
//  * Fetch a district manager commission report.
//  *
//  * @param {{ year: number, periodType: "month"|"quarter"|"ytd", month?: number, quarter?: string }} opts
//  */
// export async function getDistrictManagerCommissions({
//   year,
//   periodType,
//   month,
//   quarter,
// }) {
//   const params = new URLSearchParams();
//   params.set("year", String(year));

//   if (periodType === "month") {
//     params.set("month", String(month)); // e.g. "4"
//   } else if (periodType === "quarter") {
//     params.set("q", quarter); // e.g. "q2"
//   } else {
//     params.set("ytd", "true"); // controller checks ytd === "true"
//   }

//   const url = `${COMMISSIONS_BASE}?${params.toString()}`;
//   console.log("Fetching commission report:", url);

//   console.log("Constructed URL for commission report:", url);

//   const res = await fetch(url);
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to fetch commission report: ${errorText}`);
//   }

//   const json = await res.json();
//   if (!json.success) throw new Error(json.message);
//   return json.data;
// }
